/**
 * @generated SignedSource<<e8cfb5046b85cc0bea363c8f2e6e691b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductizedServiceAdminActions_productizedService$data = {
  readonly id: string;
  readonly searchRankBoost: number;
  readonly " $fragmentType": "ProductizedServiceAdminActions_productizedService";
};
export type ProductizedServiceAdminActions_productizedService$key = {
  readonly " $data"?: ProductizedServiceAdminActions_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceAdminActions_productizedService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductizedServiceAdminActions_productizedService",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchRankBoost",
      "storageKey": null
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};

(node as any).hash = "6b9b93097e6e8d55e89fed39e66d0329";

export default node;
